// This function component is rendered inside the main Router in 'App.js'
// Provides the routes for each page 
// A custom routing component that we can add animations too

import React from 'react';
// pages
import Home from '../pages/Home';
import About from '../pages/About';
import Portfolio from '../pages/Portfolio';
import Contact from '../pages/Contact';
import UnderConstruction from '../pages/UnderConstruction';

// routes route & useLocation hook
import { Routes, Route, useLocation } from 'react-router-dom'

import { UNDER_CONSTRUCTION } from '../siteConfig';

const AnimRoutes = () => {
  return (
  <Routes>
    <Route path='/' element={UNDER_CONSTRUCTION ? <UnderConstruction /> : <Home />}/>
    <Route path='/about' element={<About />}/>
    <Route path='/portfolio' element={<Portfolio />}/>
    <Route path='/contact' element={<Contact />}/>
  </Routes>
  );
};

export default AnimRoutes;
